import { render, staticRenderFns } from "./integrateManagement.vue?vue&type=template&id=23a42246&scoped=true&"
import script from "./integrateManagement.vue?vue&type=script&lang=js&"
export * from "./integrateManagement.vue?vue&type=script&lang=js&"
import style0 from "./integrateManagement.vue?vue&type=style&index=0&id=23a42246&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23a42246",
  null
  
)

export default component.exports